import gsap from "@lib/gsap";
import { onDestroy, onView } from "@/modules/_";

type PreparedPath = {
  path: SVGPathElement;
  len: number;
  delay: number;
  duration: number;
};

const PATH_CONFIGS = [
  { selector: ".cta-banner_visual-01 path", delay: 0, duration: 2.8 },
  { selector: ".cta-banner_visual-02 path", delay: 0.35, duration: 3.2 },
];

export default function (element: HTMLElement, _dataset: DOMStringMap) {
  const prepared: PreparedPath[] = [];

  for (const config of PATH_CONFIGS) {
    const path = element.querySelector(config.selector);
    if (!(path instanceof SVGPathElement)) continue;

    // Guard against invalid SVG paths in exported markup
    if (typeof path.getTotalLength !== "function") continue;

    const len = path.getTotalLength();
    if (!Number.isFinite(len) || len <= 0) continue;

    gsap.set(path, { strokeDasharray: len, strokeDashoffset: len });
    prepared.push({ path, len, delay: config.delay, duration: config.duration });
  }

  if (!prepared.length) return;

  let hasPlayed = false;

  onView(element, {
    threshold: 0.2,
    autoStart: true,
    callback: ({ isIn }) => {
      if (!isIn || hasPlayed) return;
      hasPlayed = true;

      for (const item of prepared) {
        gsap.to(item.path, {
          strokeDashoffset: item.len * 0.02,
          delay: item.delay,
          duration: item.duration,
          ease: "power3.out",
          overwrite: "auto",
        });
      }
    },
  });

  onDestroy(() => {
    for (const item of prepared) {
      gsap.killTweensOf(item.path);
      gsap.set(item.path, { clearProps: "strokeDasharray,strokeDashoffset" });
    }
  });
}
